export default "__VITE_ASSET__BZiEQOaE__"